<template>
    <div class="DocumentActionHeader">
        <div class="flex flex-1 flex-col gap-3">
            <div class="flex gap-1 items-center">
                <NewButton
                    variant="flat"
                    size="icon"
                    color="secondary"
                    title="Back"
                    aria-label="Back"
                    @click="$emit('back')"
                >
                    <EidIcon :icon-src="iconBack" />
                </NewButton>
                <span class="DocumentActionHeader__title">{{ title }}</span>
            </div>
            <div class="DocumentActionHeader__subtitle">
                {{ subtitle }}
            </div>
        </div>
        <div v-if="hasActions" class="DocumentActionHeader__actions">
            <NewButton
                v-if="secondaryActionLabel"
                variant="outline"
                color="danger"
                :disabled="actionsDisabled"
                @click="$emit('secondary-action')"
            >
                {{ secondaryActionLabel }}
            </NewButton>
            <NewButton
                v-if="primaryActionLabel"
                color="primary"
                :disabled="actionsDisabled"
                @click="$emit('primary-action')"
            >
                {{ primaryActionLabel }}
            </NewButton>
        </div>
    </div>
</template>

<style lang="scss">
.DocumentActionHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--eidWhite);
    padding: 21px;
    border-bottom: 1px solid var(--eidSecureBlue-10);
    gap: 32px;

    &__title {
        font-size: 24px;
        line-height: 32px;
        font-weight: 500;
    }

    &__subtitle {
        font-size: 14px;
        line-height: 20px;
    }

    &__actions {
        display: flex;
        gap: 8px;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faAngleLeft } from '@fortawesome/pro-light-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'DocumentActionHeader',
        components: {
            EidIcon,
            NewButton,
        },
        props: {
            title: {
                type: String as PropType<string>,
                required: true,
            },
            subtitle: {
                type: String as PropType<string>,
                required: true,
            },
            primaryActionLabel: {
                type: String as PropType<string | null>,
                default: 'Complete Review',
            },
            secondaryActionLabel: {
                type: String as PropType<string | null>,
                default: 'Decline Document',
            },
            actionsDisabled: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'back', 'primary-action', 'secondary-action' ],
        data() {
            return {
                iconBack: faAngleLeft,
            };
        },
        computed: {
            hasActions(): boolean {
                return Boolean((this as any).primaryActionLabel || (this as any).secondaryActionLabel);
            },
        },
    });
</script>
